// A fresh document after sign-in, sign-out or a 401 is the simplest guarantee that no Apollo
// cache, React state or loader state survives across identities.
export const hardNavigate = (path: string): void => window.location.assign(path);
